import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { CacheService } from "@delon/cache";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzModalRef } from "ng-zorro-antd/modal";
@Component({
  selector: "v4-room-types-modal-select",
  templateUrl: "./room-types-modal-select.component.html",
  styleUrls: ["./room-types-modal-select.component.scss"],
})
export class V4RoomTypesModalSelectComponent implements OnInit {
  readonly listApi = "/api/house_type/list";
  @Input() mode: "multi" | "single" = "multi";
  @Input() selectedValues: number[];
  listOfData: Option[] = [];
  listOfTagOption: Option[];
  form: UntypedFormGroup = this.fb.group({
    title: null,
    house_tag_id: null,
  });
  constructor(
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private cache: CacheService,
    private modalRef: NzModalRef,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    this.fetchDataList();
    this.fetchTagList();
    this.subscribeFormChange();
  }

  private subscribeFormChange() {
    this.form.valueChanges.subscribe(() => {
      this.fetchDataList();
    });
  }

  fetchDataList() {
    const value = this.form.value;
    const params = {
      ...value,
      page: 1,
      page_size: 10000,
    };
    if (value.house_tag_id) {
      Object.assign(params, {
        house_tag_type: "include",
        house_tag_id: JSON.stringify([value.house_tag_id]),
      });
    }
    this.http.get(this.listApi, { params }).subscribe((rst: any) => {
      this.listOfData = rst?.data?.list?.map((item) => ({
        label: item.title,
        value: item.id,
      }));
      console.log("listOfData: ", this.listOfData);
    });
  }

  private fetchTagList() {
    return this.cache
      .get("/api/house_status_setting/get", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.house_tag?.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        this.listOfTagOption = [
          {
            label: this.t.t("word.any"),
            value: null,
          },
        ].concat(list);
      });
  }

  onConfirm(options: Option[]) {
    // this.modalRef.destroy(options);
    this.modalRef.destroy({ status: "ok", data: options });
    console.log("onConfirm: ", options);
  }

  onCancel() {
    this.modalRef.destroy({ status: "cancel" });
  }

  onReset() {
    this.selectedValues = [];
  }
}
